import {connect} from "react-redux";
import {default as List} from "./FilmList";
import {default as ListForm} from "./FilmListForm";
import {actions} from "./logic/filmFormActions";
import {default as ListV} from "./FilmListViews";
import {actions as listActions} from "./logic/filmListActions";


export const FilmList = connect(
    (state) => ({
        loadStatus: state.filmReleaseList.loadStatus,
        list:state.filmReleaseList.list,
        maxResults:state.filmReleaseList.maxResults,
        filmReleaseHistory: state.filmReleaseList.frHistory,
        filmReleaseHistoryList: state.filmReleaseList.frHistoryList,
        selectedFilmRelease:state.filmReleaseList.searchForm.filmRelease,
    }),function mapDispatchToProps(dispatch) {
        return {
            toggleFilmReleaseForm: (editing,id) => dispatch(actions.TOGGLE_FILM_RELEASE_FORM.send({editing,id})),
            onSelectFilmReleaseHistory: (filmRelease) => dispatch(listActions.ON_SEARCH_FILM_RELEASE_HISTORY.send(filmRelease)),
            onSelectFilmRelease: (filmRelease) => dispatch(listActions.ON_SELECT_FILM_RELEASE.call(filmRelease)),
        };
    })(List);

export const FilmListView = connect(
    (state) => ({
        loadStatus: state.filmReleaseList.loadStatus,
        isListView: state.filmReleaseList.isListView,
        selectedFilmRelease:state.filmReleaseList.searchForm.filmRelease,
        order: state.filmReleaseList.order,
        orderBy: state.filmReleaseList.orderBy,
        filmReleaseFormOpen: state.filmReleaseForm.open,
        filmReleaseHistory: state.filmReleaseList.frHistory,
        filmReleaseHistoryList: state.filmReleaseList.frHistoryList,
    }), (dispatch) => ({
        onChangePage: (page) => dispatch(listActions.ON_CHANGE_PAGINATION_PAGE.call(page)),
        onChangeMaxResults:(maxResults) => dispatch(listActions.ON_CHANGE_PAGINATION_MAX_RESULTS.call(maxResults)),
        toggleFilmReleaseForm: (editing,id) => dispatch(actions.TOGGLE_FILM_RELEASE_FORM.send({editing,id})),
        onRefresh: () => dispatch(listActions.REFRESH_TABLE.send()),
        changeOrder: (payload) => dispatch(listActions.ON_CHANGE_ORDER.call(payload)),
        onSelectFilmReleaseHistory: (filmRelease) => dispatch(listActions.ON_SEARCH_FILM_RELEASE_HISTORY.send(filmRelease)),
    }))(ListV);

export const FilmListForm = connect(
    (state) => ({
        loadStatus: state.filmReleaseList.loadStatus,
        searchForm:state.filmReleaseList.searchForm,
    }), (dispatch) => ({
        onSelectFilmRelease: (filmRelease) => dispatch(listActions.ON_SELECT_FILM_RELEASE.call(filmRelease)),
        onSearch  : (form) =>   dispatch(listActions.ON_SEARCH_FILM_RELEASE.send(form)),
    }))(ListForm);